"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[1380],{

/***/ 51877:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ BodySection_BodySection)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/dataDisplay/RichText/RichText.tsx + 1 modules
var RichText = __webpack_require__(44946);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
;// CONCATENATED MODULE: ./src/compositions/dynamicPages/BodySection/components/GiftHubSection/components/GiftHubCard/GiftHubCard.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const GiftHubCard_module = ({"size-1":"zi_2rw","size-2":"BaqsaY","size-3":"IC6US5","children-full-width":"aqX_N4"});
;// CONCATENATED MODULE: ./src/compositions/dynamicPages/BodySection/components/GiftHubSection/components/GiftHubCard/GiftHubCard.tsx








const sizeToClassName = [
    GiftHubCard_module["size-1"],
    GiftHubCard_module["size-2"],
    GiftHubCard_module["size-3"]
];
const variantToClassName = {
    basic: "p-24",
    offer: "flex h-full w-full items-end justify-center p-12"
};
const GiftHubCard = (props)=>{
    const { className, data } = props;
    const { desktopImage, desktopOrder = 0, desktopText, desktopWhite, label, link, mixpanelGiftType, mobileImage, mobileOrder = 0, mobileText, mobileWhite, size = 1, variant = "basic" } = data;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const withLink = Boolean(link);
    const text = isMobile ? mobileText : desktopText;
    const image = isMobile ? mobileImage : desktopImage;
    const white = isMobile ? mobileWhite : desktopWhite;
    const orderStyle = {
        order: isMobile ? mobileOrder : desktopOrder
    };
    const sizeClassName = sizeToClassName[size - 1];
    const variantClassName = variantToClassName[variant];
    const containerClassName = (0,clsx/* default */.Z)(className, "relative", isMobile ? GiftHubCard_module["size-3"] : sizeClassName, !isMobile && "h-[304rem]");
    const content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                className: "h-full w-full object-cover",
                src: image?.data?.attributes?.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)("absolute left-0 top-0 z-[1] h-full w-full", label && (isMobile ? "py-20" : "flex items-center")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx/* default */.Z)(variantClassName, GiftHubCard_module["children-full-width"], {
                        "inline-block bg-black py-16": label,
                        "text-white": white
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        message: text
                    })
                })
            })
        ]
    });
    if (withLink) {
        const handleClick = ()=>{
            (0,analytics/* track */.j)("Gift explore click", {
                giftType: mixpanelGiftType?.replace(/_/g, " "),
                link
            });
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
            to: link,
            className: containerClassName,
            style: orderStyle,
            onClick: handleClick,
            children: content
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: containerClassName,
        style: orderStyle,
        children: content
    });
};
/* harmony default export */ const GiftHubCard_GiftHubCard = (GiftHubCard);

;// CONCATENATED MODULE: ./src/compositions/dynamicPages/BodySection/components/GiftHubSection/GiftHubSection.tsx





const GiftHubSection = (props)=>{
    const { data } = props;
    const { cards } = data;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)("flex flex-wrap gap-16", isMobile ? "mt-40" : "mt-60"),
        children: cards.map((card)=>{
            const { id } = card;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftHubCard_GiftHubCard, {
                data: card
            }, id);
        })
    });
};
/* harmony default export */ const GiftHubSection_GiftHubSection = (GiftHubSection);

// EXTERNAL MODULE: ./local_modules/local-storage/index.ts + 2 modules
var local_storage = __webpack_require__(55222);
// EXTERNAL MODULE: ./local_modules/notifications/manager.ts
var manager = __webpack_require__(72065);
;// CONCATENATED MODULE: ./src/compositions/dynamicPages/BodySection/components/PageNotification/PageNotification.tsx



const PageNotification = (props)=>{
    const { data } = props;
    (0,react.useEffect)(()=>{
        if (!data) {
            return;
        }
        const { notificationGroup, text, title, titleColor } = data;
        if (!local_storage/* default */.Z.getSessionItem(notificationGroup)) {
            local_storage/* default */.Z.setSessionItem(notificationGroup, true);
            (0,manager/* openNotification */.Ym)("plain", {
                title,
                text,
                titleColor: titleColor ? titleColor.replace(/_/g, "-") : null
            });
        }
    }, [
        data
    ]);
    return null;
};
/* harmony default export */ const PageNotification_PageNotification = (PageNotification);

;// CONCATENATED MODULE: ./src/compositions/dynamicPages/BodySection/BodySection.tsx




const ComponentsMap = {
    "ComponentPageGiftHubSection": GiftHubSection_GiftHubSection,
    "ComponentPagePageNotification": PageNotification_PageNotification,
    "ComponentPageContentSlot": -1
};
const BodySection = (props)=>{
    const { contentSlot, data = [] } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data.map((section, index)=>{
            const Component = ComponentsMap[section.__typename];
            if (Component === -1) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: contentSlot
                }, index);
            }
            if (!Component) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                data: section
            }, index);
        })
    });
};
/* harmony default export */ const BodySection_BodySection = (BodySection);


/***/ }),

/***/ 45914:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HeroSection_HeroSection)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/dataDisplay/HeroMediaBlock/HeroMediaBlock.tsx + 1 modules
var HeroMediaBlock = __webpack_require__(68155);
// EXTERNAL MODULE: ./src/components/dataDisplay/RichText/RichText.tsx + 1 modules
var RichText = __webpack_require__(44946);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
;// CONCATENATED MODULE: ./src/compositions/dynamicPages/HeroSection/components/DefaultHero/DefaultHero.tsx





const DEFAULT_HEIGHT_DESKTOP = 520;
const DEFAULT_HEIGHT_MOBILE = 400;
const DefaultHero = (props)=>{
    const { className, data } = props;
    const { heroImage, heroText } = data;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const image = isMobile ? heroImage?.mobile?.data?.attributes : heroImage?.desktop?.data?.attributes;
    const imageHeight = isMobile ? heroImage?.mobileHeight || DEFAULT_HEIGHT_MOBILE : heroImage?.desktopHeight || DEFAULT_HEIGHT_DESKTOP;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            Boolean(image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMediaBlock/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMediaBlock/* default */.Z.Image, {
                    src: image?.url,
                    height: imageHeight
                })
            }),
            Boolean(heroText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                    message: isMobile ? heroText.mobile : heroText.desktop
                })
            })
        ]
    });
};
/* harmony default export */ const DefaultHero_DefaultHero = (DefaultHero);

// EXTERNAL MODULE: ./src/components/layout/AspectContainer/AspectContainer.tsx
var AspectContainer = __webpack_require__(39682);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
;// CONCATENATED MODULE: ./src/compositions/dynamicPages/HeroSection/components/GiftCardHero/GiftCardHero.tsx





const GiftCardHero = (props)=>{
    const { className, data } = props;
    const { heroImage, heroText } = data;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const image = isMobile ? heroImage?.mobile?.data?.attributes : heroImage?.desktop?.data?.attributes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            Boolean(image) && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: image.url,
                    fullWidth: true
                })
            }),
            Boolean(image) && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: image.url,
                fullWidth: true
            }),
            Boolean(heroText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                className: "relative mt-[-18rem] pl-16",
                message: isMobile ? heroText.mobile : heroText.desktop
            })
        ]
    });
};
/* harmony default export */ const GiftCardHero_GiftCardHero = (GiftCardHero);

// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/compositions/dynamicPages/HeroSection/components/GiftHubHero/GiftHubHero.tsx





const GiftHubHero = (props)=>{
    const { className, data } = props;
    const { heroText, label: labelImage } = data;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const label = isMobile ? labelImage?.mobile?.data?.attributes : labelImage?.desktop?.data?.attributes;
    const height = isMobile ? labelImage.mobileHeight : labelImage.desktopHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "text-center"),
        children: [
            Boolean(label) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                className: "max-w-full",
                src: label.url,
                style: {
                    height: height ? `${height}rem` : undefined
                }
            }),
            Boolean(heroText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                message: isMobile ? heroText.mobile : heroText.desktop
            })
        ]
    });
};
/* harmony default export */ const GiftHubHero_GiftHubHero = (GiftHubHero);

// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/components/dataDisplay/Label/Label.tsx + 1 modules
var Label = __webpack_require__(10016);
// EXTERNAL MODULE: ./src/components/navigation/Breadcrumbs/Breadcrumbs.tsx + 2 modules
var Breadcrumbs = __webpack_require__(23374);
;// CONCATENATED MODULE: ./src/compositions/dynamicPages/HeroSection/components/GiftPageHero/messages.ts
/* harmony default export */ const messages = ({
    breadcrumbs: {
        root: {
            en: "Gifts"
        },
        current: {
            en: "Gift subscription"
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/dynamicPages/HeroSection/components/GiftPageHero/GiftPageHero.tsx








const breadcrumbs = [
    {
        title: messages.breadcrumbs.root,
        to: links/* default */.ZP.gifts
    },
    {
        title: messages.breadcrumbs.current
    }
];
const GiftPageHero_DEFAULT_HEIGHT_DESKTOP = 250;
const GiftPageHero_DEFAULT_HEIGHT_MOBILE = 178;
const normalizeColor = (color)=>{
    return color?.replace(/_/g, "-");
};
const GiftPageHero = (props)=>{
    const { className, data } = props;
    const { heroDescription, heroImage, heroTitle, labelText, labelBackgroundColor, labelTextColor } = data;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const image = isMobile ? heroImage?.mobile?.data?.attributes : heroImage?.desktop?.data?.attributes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            Boolean(image) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroMediaBlock/* default */.Z, {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMediaBlock/* default */.Z.Image, {
                        src: image?.url,
                        height: isMobile ? GiftPageHero_DEFAULT_HEIGHT_MOBILE : GiftPageHero_DEFAULT_HEIGHT_DESKTOP
                    }),
                    Boolean(labelText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.ZP, {
                        className: "left-0 bottom-24",
                        title: labelText,
                        absolute: true,
                        bgColor: normalizeColor(labelBackgroundColor) || "brown-red",
                        textColor: normalizeColor(labelTextColor) || "white",
                        indent: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                        className: "mt-24",
                        items: breadcrumbs
                    }),
                    Boolean(heroTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        className: "text-left",
                        message: isMobile ? heroTitle.mobile : heroTitle.desktop
                    }),
                    Boolean(heroDescription) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        className: "text-left",
                        message: isMobile ? heroDescription.mobile : heroDescription.desktop
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const GiftPageHero_GiftPageHero = (GiftPageHero);

;// CONCATENATED MODULE: ./src/compositions/dynamicPages/HeroSection/components/HeroWithLabel/HeroWithLabel.tsx






const HeroWithLabel_DEFAULT_HEIGHT_DESKTOP = 520;
const HeroWithLabel_DEFAULT_HEIGHT_MOBILE = 400;
const HeroWithLabel = (props)=>{
    const { className, data } = props;
    const { heroImage, heroText, label } = data;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const image = isMobile ? heroImage?.mobile?.data?.attributes : heroImage?.desktop?.data?.attributes;
    const labelImage = isMobile ? label?.mobile?.data?.attributes : label?.desktop?.data?.attributes;
    const withHeroBlock = Boolean(image || labelImage);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            withHeroBlock && /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroMediaBlock/* default */.Z, {
                children: [
                    Boolean(image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMediaBlock/* default */.Z.Image, {
                        src: image.url,
                        height: isMobile ? HeroWithLabel_DEFAULT_HEIGHT_MOBILE : HeroWithLabel_DEFAULT_HEIGHT_DESKTOP
                    }),
                    Boolean(labelImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx/* default */.Z)("text-center", isMobile ? "mt-[-94rem]" : "mt-[-120rem]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: labelImage.url,
                            alt: labelImage.alternativeText,
                            width: isMobile ? 125 : 149
                        })
                    })
                ]
            }),
            Boolean(heroText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                    message: isMobile ? heroText.mobile : heroText.desktop
                })
            })
        ]
    });
};
/* harmony default export */ const HeroWithLabel_HeroWithLabel = (HeroWithLabel);

;// CONCATENATED MODULE: ./src/compositions/dynamicPages/HeroSection/components/OfferBanner/OfferBanner.tsx






const OfferBanner = (props)=>{
    const { data } = props;
    const { desktop, image, logo, mobile, text } = data;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const isVisible = isMobile ? mobile : desktop;
    if (!isVisible) {
        return null;
    }
    const offerImage = isMobile ? image?.mobile?.data?.attributes : image?.desktop?.data?.attributes;
    const logoImage = isMobile ? logo?.mobile?.data?.attributes : logo?.desktop?.data?.attributes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx/* default */.Z)("flex items-center rounded bg-light-beige p-12", isMobile ? "mt-24" : ""),
            children: [
                Boolean(offerImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    className: "mr-8 flex h-88 w-[132rem] object-contain",
                    src: offerImage.url
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center",
                    children: [
                        Boolean(logoImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            className: "max-h-24",
                            src: logoImage.url
                        }),
                        Boolean(text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                            message: isMobile ? text.mobile : text.desktop
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const OfferBanner_OfferBanner = (OfferBanner);

;// CONCATENATED MODULE: ./src/compositions/dynamicPages/HeroSection/HeroSection.tsx








const ComponentsMap = {
    "ComponentPageDefaultHero": DefaultHero_DefaultHero,
    "ComponentPageGiftCardHero": GiftCardHero_GiftCardHero,
    "ComponentPageGiftHubHero": GiftHubHero_GiftHubHero,
    "ComponentPageGiftPageHero": GiftPageHero_GiftPageHero,
    "ComponentPageHeroWithLabel": HeroWithLabel_HeroWithLabel,
    "ComponentPageOfferBanner": OfferBanner_OfferBanner,
    "ComponentPageContentSlot": -1
};
const HeroSection = (props)=>{
    const { className, contentSlot, data = [] } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data.map((section, index)=>{
            const Component = ComponentsMap[section.__typename];
            if (Component === -1) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: contentSlot
                }, index);
            }
            if (!Component) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                className: index === 0 && className,
                data: section
            }, index);
        })
    });
};
/* harmony default export */ const HeroSection_HeroSection = (HeroSection);


/***/ })

}]);